import { Box, BoxProps } from '@mui/material';

interface TabPanelProps {
    children?: React.ReactNode;
    currentActiveTab: string;
    tabName: string;
    sx?: BoxProps['sx'];
}

export const TabPanel = ({ children, tabName, currentActiveTab, sx, ...other }: TabPanelProps) => {
    return (
        <div
            role="tabpanel"
            hidden={tabName !== currentActiveTab}
            id={`spotter-details-tabpanel-${currentActiveTab}`}
            aria-labelledby={`spotter-details-tab-${currentActiveTab}`}
            {...other}
        >
            {tabName === currentActiveTab && <Box sx={{ my: 6, mx: 1, ...sx }}>{children}</Box>}
        </div>
    );
};
